
import { RoadmapItem } from "@/models/roadmap-item";
import { RoadmapService } from "@/services/roadmap-service";
import { App } from "@/utils/apps";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			items: [] as RoadmapItem[]
		};
	},
	computed: {
		sortableAttributes():any{
			return {
				tag: "w-list",
				disableX: true,
				keepInY: true,
				targetClass: "handle",
				items: this.items
			};
		}
	},
	methods: {
		async save(){
			this.items.forEach((item, i)=>{
				item.priority = i+1;
			});
			await RoadmapService.setPriorities(this.items);
			this.$router.push("/roadmap");
		}
	},
	async created(){
		this.items = await RoadmapService.getItemsByAppName(this.$route.params.appName as App);
	}
});
